// extracted by mini-css-extract-plugin
export var aboveInput = "_lj-0";
export var actionButton = "_lj-5";
export var actionButtonContainer = "_lj-1";
export var actionIcon = "_lj-6";
export var aiInfoContainer = "_lj-2";
export var attachmentWrapper = "_lj-7";
export var bold = "_lj-3";
export var checkIcon = "_lj-8";
export var clickingRecipientBar = "_lj-11";
export var commentThreadSwitch = "_lj-a";
export var draftImage = "_lj-b";
export var draftImageContainer = "_lj-c";
export var draftImages = "_lj-e";
export var editButton = "_lj-g";
export var editor = "_lj-f";
export var editorContainer = "_lj-y";
export var editorErrorTooltipWrapper = "_lj-9";
export var headerDivider = "_lj-h";
export var icon = "_lj-i";
export var info = "_lj-j";
export var internal = "_lj-n";
export var internalDivider = "_lj-k";
export var internalMessage = "_lj-l";
export var messageInputCard = "_lj-m";
export var messageInputForm = "_lj-o";
export var messageInputFormInternal = "_lj-p";
export var options = "_lj-q";
export var publicMessageCustomer = "_lj-s";
export var publicMessageMerchant = "_lj-r";
export var removeImageButton = "_lj-d";
export var replyButtons = "_lj-t";
export var showSignatureButton = "_lj-u";
export var spinner = "_lj-v";
export var verticalButtonDivider = "_lj-4";
export var visibilitySelector = "_lj-w";
export var warning = "_lj-x";
export var wrappingText = "_lj-z";
export var writingInternalNoteTopBorder = "_lj-10";